<template>
  <section class="section blog--section">
    <div class="container-lg">
      <div class="section__header">

        <div class="row">
          <div class="col-sm-8">
            <h2 class="section__title">{{ in18['page_blog_title'] }}</h2>
            <div class="section__text">{{ in18['page_blog_description'] }}</div>
          </div>
          <div class="col-sm-4">
            <div class="text-right  text-left-sm">
              <a :href="blog_link" :title="in18['page_see_all']" class="link  link--blue  fw-500">
                {{ in18['page_see_all'] }} »
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-for="blog_article in blog_articles" class="col-lg-4  mb-5">
          <div class="card">
            <div class="card__preview">
              <a :href="blog_article.link" :title="blog_article.title">
                <picture>
                  <source :srcset="blog_article.image.webp" type="image/webp">
                  <img :alt="blog_article.title" :src="blog_article.image.source">
                </picture>
              </a>
            </div>
            <div class="card__content">
              <time :datetime="blog_article.created_at" class="card__pubdate">
                {{ blog_article.created_at }}
              </time>
              <h3 class="card__title">
                <a :href="blog_article.link" :title="blog_article.title">
                  {{ blog_article.title }}
                </a>
              </h3>
              <div class="card__text">
                {{ blog_article.short_description }}
              </div>
              <a :href="blog_article.link" :title="blog_article.title" class="link  link--post">
                {{ in18['page_read_all'] }} ›
              </a>
            </div>
          </div>
        </div>
      </div><!-- /.row -->

    </div><!-- /.container -->
  </section>
</template>

<script>
export default {
  name:  "BlogArticles",
  props: [
    'in18',
    'blog_articles',
    'blog_link'
  ],
}
</script>
